(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyTooltipIcon", [
    "$timeout",
    "GenerateUuid",
    function ($timeout, GenerateUuid) {
      var controller = function () {
        var ctl = this;

        $timeout(function () {
          ctl.calloutOriginId = "ty-tooltip-callout-origin-" + GenerateUuid();
        });
      };

      return {
        restrict: "E",
        scope: {},
        bindToController: {
          href: "@href",
        },
        controller: controller,
        controllerAs: "ctl",
        replace: true,
        transclude: true,
        // prettier-ignore
        template:
          '<span class="ty-tooltip-icon">' +
            '<span id="{{ctl.calloutOriginId}}" class="ty-tooltip-icon__callout-origin">' +
              "<ng-transclude></ng-transclude>" +
            "</span>" +
            '<a class="ty-tooltip-icon__button" href="{{ctl.href}}" data-ty-tooltip-callout-origin-selector="#{{ctl.calloutOriginId}}">' +
              '<ty-svg-icon icon-id="tooltip"></ty-svg-icon>' +
            "</a>" +
          "</span>",
        link: function (scope, element) {
          angular.element(element).removeAttr("href"); // "replace: true" doesn't do what you think it does -- let's fix that
        },
      };
    },
  ]);
})(window.angular);
